/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Query = {
    /**
     * ID of the query
     */
    id: string;
    /**
     * ID of the workspace
     */
    workspaceId: string;
    /**
     * ID of the project
     */
    projectId: string;
    createdBy: string;
    ownerId: string;
    lastEditedBy: string;
    /**
     * Name of the query
     */
    name: string;
    /**
     * Description of the query
     */
    description: string | null;
    parameters: {
        /**
         * Aggregates to compute when running the query
         */
        calculations?: Array<{
            key?: string;
            operator: 'uniq' | 'count' | 'max' | 'min' | 'sum' | 'avg' | 'median' | 'p001' | 'p01' | 'p05' | 'p10' | 'p25' | 'p75' | 'p90' | 'p95' | 'p99' | 'p999' | 'stddev' | 'variance' | 'array_max_size' | 'array_min_size' | 'array_avg_size';
            alias?: string;
        }>;
        /**
         * How to group the query run results
         */
        groupBys?: Array<{
            type: 'string' | 'number' | 'boolean';
            value: string;
        }>;
        /**
         * How to order the results of the query
         */
        orderBy?: {
            value: string;
            order?: Query.order;
        };
        /**
         * The limit on the number of events / groups returned in the query results
         */
        limit?: number;
        /**
         * The filters to apply on the data when running the query
         */
        filters?: Array<{
            /**
             * The filters to apply on the data in this group
             */
            filters?: Array<{
                key: string;
                operation: 'exists' | 'is_null' | 'starts_with' | 'regex' | 'includes' | 'not_includes' | 'in' | 'not_in' | 'array_size' | 'array_size_gt' | 'array_size_gte' | 'array_size_lt' | 'array_size_lte' | 'array_is_empty' | 'array_not_empty' | 'array_contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                value?: (string | number | boolean);
                type: 'string' | 'number' | 'boolean' | 'array';
            }>;
            /**
             * How to combine the filters in this group
             */
            filterCombination?: 'and' | 'or';
        }>;
        /**
         * How to combine the filters across groups
         */
        filterCombination?: Query.filterCombination;
        /**
         * Expression to search on the data when running the query
         */
        needle?: {
            value: (string | number | boolean);
            isRegex?: boolean;
            matchCase?: boolean;
        };
    };
    created: string;
    updated: string;
    _object: Query._object;
};
export namespace Query {
    export enum order {
        ASC = 'asc',
        DESC = 'desc',
    }
    /**
     * How to combine the filters across groups
     */
    export enum filterCombination {
        AND = 'and',
        OR = 'or',
    }
    export enum _object {
        QUERY = 'query',
    }
}

